import moment from "moment-timezone";

import { mapToValueOrNull } from "./mapToValueOrNull";

export const mapToDateOrNull = <T>(value: T): string | NonNullable<T> | null => {
  const date = mapToValueOrNull(value);
  return typeof date === "string" && date ? new Date(date).toISOString().split("T")[0] : date;
};

// Return example: "2023-03-03" ; if includeTime: "2023-03-03T21:08:31.906Z"
export const convertDateToString = (date: Date, includeTime?: boolean): string => {
  try {
    const formattedDate = new Date(date).toISOString();
    return includeTime ? formattedDate : formattedDate.split("T")[0];
  } catch (error) {
    // Return current date in case of error.
    const currentDate = new Date().toISOString();
    return includeTime ? currentDate : currentDate.split("T")[0];
  }
};

export const treatDateAsUtc = (date: Date): Date =>
  new Date(
    Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    )
  );

export const adjustToLocalFromUTC = (date: Date | null | undefined): Date | null => {
  if (!date) {
    return null;
  }
  if (isNaN(date.getTime())) {
    return null;
  }
  // Add the local timezone offset (in minutes) to the date
  const offsetInMs = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + offsetInMs);
};

// Helper function to safely convert to Date
export const safeToDate = (value: Date | string | null | undefined): Date | null => {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === "string") {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
  return null;
};

// Helper function to safely convert Date to ISO string
export const dateToISOString = (
  date: Date | string | null | undefined
): string | null | undefined => {
  if (date instanceof Date) {
    return date.toISOString();
  }
  return date;
};

// Functions to use on the DATEPICKER on XpaModal to handle UTC back and forth
// Final compensation before sending to backend to restore original selected time
export const finalBackendCompensation = (date: Date | null): Date | null => {
  if (!date) {
    return null;
  }

  // Get user's timezone offset in minutes
  const userTimezone = moment.tz.guess();
  const userOffsetMinutes = moment.tz(date, userTimezone).utcOffset();

  // ADD the user's offset to restore the original selected time
  // This cancels the previous compensation and sends the exact time user selected
  const finalDate = moment(date).add(userOffsetMinutes, "minutes").toDate();

  return finalDate;
};
